import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Typography, Input, IconButton } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import { missionPlannerStore } from '../../stores/MissionPlannerStore';
import { SimpleItem } from '../../types/Plan';

const TakeoffSettings: React.FC = () => {
  const takeoffItemIndex = missionPlannerStore.missionItems.findIndex(
    (item) => item.type === 'SimpleItem' && item.command === 22
  );

  if (takeoffItemIndex === -1) {
    return null;
  }

  const takeoffItem = missionPlannerStore.missionItems[takeoffItemIndex] as SimpleItem;

  const handleAltitudeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newAltitude = parseFloat(event.target.value);
    if (!Number.isNaN(newAltitude)) {
      const newParams: SimpleItem['params'] = [...takeoffItem.params];
      newParams[6] = newAltitude;
      const newCoordinate: SimpleItem['coordinate'] = [...takeoffItem.coordinate];
      newCoordinate[2] = newAltitude;
      missionPlannerStore.updateMissionItem(takeoffItemIndex, { params: newParams, coordinate: newCoordinate });
    }
  };

  const handleYawChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newYaw = parseFloat(event.target.value);
    if (!Number.isNaN(newYaw)) {
      const newParams: SimpleItem['params'] = [...takeoffItem.params];
      newParams[3] = newYaw;
      missionPlannerStore.updateMissionItem(takeoffItemIndex, { params: newParams });
    }
  };

  const handleDelete = () => {
    missionPlannerStore.removeMissionItem(takeoffItemIndex);
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    missionPlannerStore.updateMissionItem(takeoffItemIndex, { name: event.target.value });
  };

  return (
    <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 'md' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography level='title-md'>Takeoff</Typography>
        <IconButton size='sm' variant='plain' color='danger' onClick={handleDelete}>
          <DeleteIcon />
        </IconButton>
      </Box>
      <Typography level='body-sm' sx={{ mb: 2 }}>
        Launch from the ground and travel towards the specified takeoff position.
      </Typography>

      <Typography level='body-sm'>Name</Typography>
      <Input placeholder='Takeoff' value={takeoffItem.name || ''} onChange={handleNameChange} sx={{ mb: 2 }} />

      <Typography level='body-sm'>Altitude</Typography>
      <Input
        type='number'
        value={takeoffItem.params[6] || ''}
        onChange={handleAltitudeChange}
        endDecorator={<Typography level='body-xs'>ft</Typography>}
        sx={{ mb: 2 }}
      />

      <Typography level='body-sm'>Yaw</Typography>
      <Input
        type='number'
        placeholder='--.--'
        value={takeoffItem.params[3] || ''}
        onChange={handleYawChange}
        endDecorator={<Typography level='body-xs'>deg</Typography>}
        sx={{ mb: 2 }}
      />

      <Typography level='body-sm'>Latitude</Typography>
      <Input readOnly value={takeoffItem.coordinate[0].toFixed(6)} sx={{ mb: 2 }} />

      <Typography level='body-sm'>Longitude</Typography>
      <Input readOnly value={takeoffItem.coordinate[1].toFixed(6)} />
    </Box>
  );
};

export default observer(TakeoffSettings);
